import { inject } from 'vue'
import { routerServiceKey } from '../router-symbol'

export function useRouterService() {
  const routerService = inject(routerServiceKey)

  if (!routerService) {
    throw new Error('could not find router-service provider. Did you provide it in your app?')
  }

  return routerService
}
